import React from 'react'
import clsx from 'clsx'
import RSelect, { components } from 'react-select'
import { ReactComponent as IconArrow } from 'images/arrow-down-w.svg';
import styles from './Select.module.scss';

export type OptionType = {
  value: string,
  label: string,
  icon?: string,
}

export type SelectProps = {
  value?: OptionType,
  onChange?: (v: any) => void,
  className?: string,
  options: OptionType[] | any,
  optionClassName?: string,
  secondary?: boolean,
}

function DropdownIndicator(props: any) {
  return (<IconArrow {...props} className={styles.dropdownIndicator} />)
}

const { Option, SingleValue } = components;

function IconOption(props: any) {
  return (
    <Option {...props}>
      <img
        src={props?.data?.icon}
        alt={props?.data?.label}
      />
      {props?.data?.label}
    </Option>
  )
}

function IconSingleValue(props: any) {
  
  return (
    <SingleValue {...props}>
      <img
        src={props?.data?.icon}
        alt={props?.data?.label}
      />
      {props?.data?.label}
    </SingleValue>
  )
}

export function SelectWithIcon({
  value = undefined,
  onChange = () => {},
  options = [],
  className = '',
  optionClassName = '',
  secondary = false,
}: SelectProps) {
  const style = {
    menuList: (base) => ({
      ...base,

      '::-webkit-scrollbar': {
        width: '4px',
        height: '0px',
      },
      '::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '::-webkit-scrollbar-thumb': {
        background: '#888',
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  }
  return (
    <RSelect
      classNames={{
        container: () => clsx(
          className,
          styles.select,
          styles.selectWithIcon,
          !value && styles.selectNoValue,
          secondary && styles.select_secondary,
        ),
        indicatorSeparator: () => styles.indicatorSeparator,
        control: () => styles.control,
        valueContainer: () => styles.valueContainer,
        singleValue: () => styles.singleValue,
        menu: () => clsx(optionClassName, styles.menu),
        menuList: () => styles.menuList,
        option: (props: any) => clsx(styles.option, props.isSelected && styles.optionSelected),
        placeholder: () => styles.placeholder,
      }}
      styles={style}
      components={{ Option: IconOption, DropdownIndicator, SingleValue: IconSingleValue }}
      value={value}
      onChange={onChange}
      options={options}
      isSearchable={false}
      // defaultMenuIsOpen
    />
  )
}
